async function setToken() {
    let token = await fetch('/refresh-token')
        .then((res) => res.json())
        .then((data) => {
            return data.token;
        })
        .catch((err) => {
            console.error('Could not refresh CSRF token!');
            console.error(err);
        });

    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    document.querySelector('meta[name="csrf-token"]')?.setAttribute('content', token);
    document.querySelectorAll('form input[name="_token"]').forEach((item) => {
        item.value = token;
    });
}
setToken();
setInterval(setToken, ((window.SESSION_LIFETIME * 60) / 2) * 1000);
